module.exports = __webpack_public_path__ + "img/grid-3.cfb42133.png";